import RatingAgency from './RatingAgency'

export default class Rating {
	constructor() {
		this.id = null
		this.value = null
		this.ratingAgency = new RatingAgency()
	}
}